import { NgModule } from '@angular/core';
import { UiModule } from '../ui/ui.module';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  TuiTableModule,
  TuiSortByDirective,
  TuiSortableDirective,
} from '@taiga-ui/addon-table';
import {
  TuiAvatarModule,
  TuiCellModule,
  TuiStatusModule,
  TuiIconModule,
  TuiInitialsModule,
  TuiAutoColorModule,
} from '@taiga-ui/experimental';
import {
  TuiBadgeModule,
  TuiItemsWithMoreModule,
  TuiRadioListModule,
  TuiRadioBlockModule,
  TuiPaginationModule,
  TuiCheckboxModule,
  TuiActionModule,
  TuiMarkerIconModule,
  TuiInputModule,
  TuiDataListWrapperModule,
  TuiInputDateModule,
  TUI_DATE_RANGE_VALUE_TRANSFORMER,
  TUI_DATE_VALUE_TRANSFORMER,
  TuiTextAreaModule,
  TuiSelectModule,
  TuiInputTimeModule,
  TuiInputPhoneInternationalModule,
  TuiInputNumberModule,
  TuiFilterByInputPipeModule,
  TuiStringifyPipeModule,
  TuiStringifyContentPipeModule,
  TuiComboBoxModule,
  TuiInputPasswordModule,
  TuiToggleModule,
  TuiRadioModule,
  TuiSortCountriesPipeModule,
  TuiAccordionModule,
  TuiInputFilesModule,
} from '@taiga-ui/kit';
import {
  TUI_DATE_FORMAT,
  TUI_DATE_SEPARATOR,
  TuiLetModule,
  TuiDay,
  TuiPortalModule,
  TuiDropdownHostModule,
} from '@taiga-ui/cdk';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  TuiDropdownModule,
  TuiHostedDropdownModule,
  TuiLinkModule,
  TuiSvgModule,
  TuiTextfieldControllerModule,
  TuiHintModule,
  TuiLoaderModule,
  TuiErrorModule,
  TuiTooltipModule,
  TuiRootModule,
  TuiHintsHostModule,
} from '@taiga-ui/core';
import {
  TuiCurrencyPipeModule,
  TuiFormatCardModule,
  TuiInputCVCModule,
  TuiInputCardGroupedModule,
  TuiInputCardModule,
  TuiInputExpireModule,
  TuiMoneyModule,
  TuiThumbnailCardModule,
} from '@taiga-ui/addon-commerce';
import { TuiForModule } from '@taiga-ui/cdk';
import { TuiButtonModule } from '@taiga-ui/core';
import { RouterModule } from '@angular/router';
import { GanttComponent } from './gantt/gantt.component';
import { ServiceDataModalComponent } from './service-data-modal/service-data-modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AssignerTableComponent } from './assigner-table/assigner-table.component';
import { TemporalAssignerDataTableComponent } from './temporal-assigner-data-table/temporal-assigner-data-table.component';
import { MapaComponent } from './mapa/mapa.component';
import { ModalAddAssignamentComponent } from './modal-add-assignament/modal-add-assignament.component';
import { AssignationSidebarPanelComponent } from './modal-add-assignament/components/assignation-sidebar-panel/assignation-sidebar-panel.component';
import { AssignationDriversModalComponent } from './modal-add-assignament/components/assignation-drivers-modal/assignation-drivers-modal.component';
import {
  NgbDropdownModule,
  NgbDatepickerModule,
  NgbOffcanvasModule,
  NgbModalModule,
} from '@ng-bootstrap/ng-bootstrap';
import { TuiNotificationModule } from '@taiga-ui/core';

import { ProvidersTableComponent } from './providers-table/providers-table.component';
import { ModalAddProviderComponent } from './modal-add-provider/modal-add-provider.component';
import { ClientsTableComponent } from './clients-table/clients-table.component';
import { ModalAddClientComponent } from './modal-add-client/modal-add-client.component';

import { PendingServicesComponent } from './pending-services/pending-services.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { ServiceHistoryComponent } from './service-history/service-history.component';
import { TuiInputDateRangeModule } from '@taiga-ui/kit';
import {
  ExampleDateTransformer,
  getExampleDateRangeTransformer,
} from './service-history/value.transformers';

import { PlatformBlockerTableComponent } from './platform-blocker-table/platform-blocker-table.component';

import { EditDetailContactServiceComponent } from './edit-detail-contact-service/edit-detail-contact-service.component';
import { ModalDuplicateServiceComponent } from './modal-duplicate-service/modal-duplicate-service.component';
import { TuiDataListModule } from '@taiga-ui/core';
import { ModalAddPersonalComponent } from './modal-add-personal/modal-add-personal.component';
import { ModalAddAssignmentComponent } from './modal-add-assignment/modal-add-assignment.component';
import { EventsTableComponent } from './events-table/events-table.component';
import { ModalAddBlockComponent } from './modal-add-block/modal-add-block.component';
import { TranslateEnumPipe } from '../pipes/translate-enum.pipe';
import { ModalAssignDriverComponent } from './modal-assign-driver/modal-assign-driver.component';
import { PricesTableComponent } from './prices-table/prices-table.component';
import { TranslateModule } from '@ngx-translate/core';
import { ModalAssignProviderComponent } from './modal-assign-provider/modal-assign-provider.component';
import { ModalGestionNodeComponent } from './modal-gestion-node/modal-gestion-node.component';
import { ModalAddEventOrIncidenceComponent } from './modal-add-event-or-incidence/modal-add-event-or-incidence.component';
import { ModalSendMessageComponent } from './modal-send-message/modal-send-message.component';
import { PoolManagementComponent } from './pool-management/pool-management.component';
import { ServicesNotStartedTableComponent } from './services-not-started-table/services-not-started-table.component';
import { TuiTagModule } from '@taiga-ui/kit';
import { EmergenciesTableComponent } from './emergencies-table/emergencies-table.component';
import { HistoricalTableComponent } from './historical-table/historical-table.component';
import { MapaPoolManagerComponent } from './mapa-pool-manager/mapa-pool-manager.component';
import { PoolParametersComponent } from './pool-parameters/pool-parameters.component';
import { PoolManagerBidsTableComponent } from './pool-manager-bids-table/pool-manager-bids-table.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { GanttWeeklyComponent } from './gantt-weekly/gantt-weekly.component';
import { GanttWeeklyModalComponent } from './gantt-weekly/components/gantt-weekly-modal/gantt-weekly-modal.component';
import { OrderStatusBadgePipe } from '../pipes/order-status-badge.pipe';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { ServicesWithoutProviderSideComponent } from './services-without-provider-side/services-without-provider-side.component';
import { NoProviderServiceCardComponent } from './services-without-provider-side/components/no-provider-service-card/no-provider-service-card.component';
import { SelectProviderListComponent } from './services-without-provider-side/components/select-provider-list/select-provider-list.component';
import { GanttSidebarComponent } from './gantt/components/gantt-sidebar/gantt-sidebar.component';
import { UnassignDriverModalComponent } from './gantt/components/unassign-driver-modal/unassign-driver-modal.component';
import { ModalLanguageChangeComponent } from './modal-language-change/modal-language-change.component';
import { ModalConfirmLogoutComponent } from './modal-confirm-logout/modal-confirm-logout.component';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { TimezoneDatePipe } from '../pipes/TimezoneDate.pipe';
import { TuiTabsModule } from '@taiga-ui/kit';
import { DeliveryNoteSectionComponent } from '../pages/detail-service/components/delivery-note-section/delivery-note-section.component';
import { ReportSectionComponent } from '../pages/detail-service/components/report-section/report-section.component';
import { ModalUploadDeliveryNoteComponent } from './modal-upload-delivery-note/modal-upload-delivery-note.component';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { ModalPdfViewerComponent } from './modal-pdf-viewer/modal-pdf-viewer.component';
import { FinancialInformationComponent } from './financial-information/financial-information.component';
import { VerticalNamePipe } from '../pipes/vertical-name.pipe';
import { LastUpdateFormatPipe } from '../pipes/last-update-format.pipe';
import { TUI_HINT_OPTIONS, tuiHintOptionsProvider } from '@taiga-ui/core';
import { SaveChangesModalComponent } from './financial-information/components/save-changes-modal/save-changes-modal.component';
import { SaveWithoutChangeModalComponent } from './financial-information/components/save-without-change-modal/save-without-change-modal.component';
import { AddCostModalComponent } from './financial-information/components/add-cost-modal/add-cost-modal.component';
import { EmptyValuePipe } from './pipes/empty-value.pipe';
import { EditProductParametersModalComponent } from './pool-parameters/components/edit-product-parameters-modal/edit-product-parameters-modal.component';
import { EditOperativeZoneModalComponent } from './pool-parameters/components/edit-operative-zone-modal/edit-operative-zone-modal.component';
import { ProductsTableParametersComponent } from './pool-parameters/components/products-table-parameters/products-table-parameters.component';
import { ModalDelayedServiceComponent } from './modal-delayed-service/modal-delayed-service.component';
import { ModalDelayedServiceUncheckComponent } from './modal-delayed-service-uncheck/modal-delayed-service-uncheck.component';
import { ModalCancelServiceComponent } from './modal-cancel-service/modal-cancel-service.component';
import { DocumentTypeInputComponent } from './components/document-type-input/document-type-input.component';
import { DistanceUnitPipe } from '../pipes/distance-unit.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DeliveryNoteUploadButtonComponent } from './components/delivery-note-upload-button/delivery-note-upload-button.component';
import { ExpensesSharedModule } from '../pages/expenses/shared/expenses-shared.module';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    NavbarComponent,
    GanttComponent,
    ServiceDataModalComponent,
    AssignerTableComponent,
    TemporalAssignerDataTableComponent,
    MapaComponent,
    ModalAddAssignamentComponent,
    AssignationSidebarPanelComponent,
    AssignationDriversModalComponent,

    PendingServicesComponent,
    IncidentsComponent,

    ProvidersTableComponent,
    ModalAddProviderComponent,
    ClientsTableComponent,
    ModalAddClientComponent,
    ModalAddEventOrIncidenceComponent,

    ProvidersTableComponent,
    ModalAddProviderComponent,
    PendingServicesComponent,
    IncidentsComponent,
    ServiceHistoryComponent,
    PlatformBlockerTableComponent,
    EditDetailContactServiceComponent,
    ModalDuplicateServiceComponent,
    ModalAddPersonalComponent,
    ModalAddAssignmentComponent,
    EventsTableComponent,
    ModalAddBlockComponent,
    TranslateEnumPipe,
    ModalAssignDriverComponent,
    PricesTableComponent,
    ModalAssignProviderComponent,
    ModalSendMessageComponent,
    ModalGestionNodeComponent,
    EditProductParametersModalComponent,
    EditOperativeZoneModalComponent,
    ProductsTableParametersComponent,
    PoolManagementComponent,
    ServicesNotStartedTableComponent,
    EmergenciesTableComponent,
    HistoricalTableComponent,
    MapaPoolManagerComponent,
    PoolParametersComponent,
    PoolManagerBidsTableComponent,
    GanttWeeklyComponent,
    GanttWeeklyModalComponent,
    PhoneInputComponent,
    ServicesWithoutProviderSideComponent,
    NoProviderServiceCardComponent,
    SelectProviderListComponent,
    GanttSidebarComponent,
    UnassignDriverModalComponent,
    ModalLanguageChangeComponent,
    ModalConfirmLogoutComponent,
    CustomDropdownComponent,
    TimezoneDatePipe,
    FinancialInformationComponent,
    SaveChangesModalComponent,
    SaveWithoutChangeModalComponent,
    AddCostModalComponent,
    EmptyValuePipe,
    ModalDelayedServiceComponent,
    ModalDelayedServiceUncheckComponent,
    ModalCancelServiceComponent,
    DeliveryNoteSectionComponent,
    ReportSectionComponent,
    ModalUploadDeliveryNoteComponent,
    ModalConfirmComponent,
    ModalPdfViewerComponent,

    //Shared components 
    DocumentTypeInputComponent,
    DistanceUnitPipe,
    DeliveryNoteUploadButtonComponent,
  ],
  imports: [
    CommonModule,
    UiModule,
    TuiLetModule,
    TuiTableModule,
    TuiItemsWithMoreModule,
    TuiBadgeModule,
    TuiAvatarModule,
    FormsModule,
    ReactiveFormsModule,
    TuiRadioListModule,
    TuiRadioBlockModule,
    TuiCellModule,
    TuiStatusModule,
    TuiLinkModule,
    TuiIconModule,
    TuiInitialsModule,
    TuiCurrencyPipeModule,
    TuiFormatCardModule,
    TuiInputCVCModule,
    TuiInputCardGroupedModule,
    TuiInputCardModule,
    TuiInputExpireModule,
    TuiMoneyModule,
    TuiThumbnailCardModule,
    TuiAutoColorModule,
    TuiForModule,
    TuiButtonModule,
    TuiPaginationModule,
    TuiHostedDropdownModule,
    TuiDropdownModule,
    TuiCheckboxModule,
    TuiActionModule,
    TuiMarkerIconModule,
    TuiInputModule,
    TuiSvgModule,
    RouterModule,
    TuiDataListWrapperModule,
    ModalModule.forRoot(),
    NgbDropdownModule,
    TuiInputDateModule,
    NgbDatepickerModule,
    TuiNotificationModule,
    NgbOffcanvasModule,
    TuiTextfieldControllerModule,
    TuiInputDateRangeModule,
    TuiTextAreaModule,
    TuiInputDateRangeModule,
    TuiDataListModule,
    TuiSelectModule,
    TuiErrorModule,
    TuiInputTimeModule,
    TuiInputPhoneInternationalModule,
    TuiHintModule,
    TuiInputNumberModule,
    TuiFilterByInputPipeModule,
    TuiStringifyPipeModule,
    TuiStringifyContentPipeModule,
    TuiComboBoxModule,
    TuiInputPasswordModule,
    TuiLoaderModule,
    NgSelectModule,
    TranslateModule.forChild(),
    TuiToggleModule,
    TuiRadioModule,
    TuiSortCountriesPipeModule,
    TuiTagModule,
    TuiHintModule,
    TuiHostedDropdownModule,
    TuiHintsHostModule,
    TuiTooltipModule,
    OrderStatusBadgePipe,
    TuiIconModule,
    TuiAccordionModule,
    TuiInputFilesModule,
    TuiRootModule,
    TuiPortalModule,
    NgbModalModule,
    TuiTabsModule,
    VerticalNamePipe,
    LastUpdateFormatPipe,
    PdfViewerModule,
    // Gastos de conductores en el desglose de precio del detalle de servicio.
    ExpensesSharedModule,
  ],
  exports: [
    UiModule,
    BreadcrumbsComponent,
    NavbarComponent,
    GanttComponent,
    ServiceDataModalComponent,
    AssignerTableComponent,
    TemporalAssignerDataTableComponent,
    MapaComponent,
    ModalAddAssignamentComponent,
    ProvidersTableComponent,
    ModalAddProviderComponent,
    ModalAddEventOrIncidenceComponent,
    ClientsTableComponent,
    ModalAddClientComponent,
    PlatformBlockerTableComponent,
    PendingServicesComponent,
    IncidentsComponent,
    ServiceHistoryComponent,
    ModalAddPersonalComponent,
    ModalAddAssignmentComponent,
    EventsTableComponent,
    ModalAddBlockComponent,
    PricesTableComponent,
    TranslateModule,
    TranslateEnumPipe,
    PoolManagementComponent,
    ServicesNotStartedTableComponent,
    EmergenciesTableComponent,
    HistoricalTableComponent,
    PoolParametersComponent,
    PoolManagerBidsTableComponent,
    GanttWeeklyComponent,
    GanttWeeklyModalComponent,
    ServicesWithoutProviderSideComponent,
    NoProviderServiceCardComponent,
    SelectProviderListComponent,
    ModalLanguageChangeComponent,
    ModalConfirmLogoutComponent,
    CustomDropdownComponent,
    TimezoneDatePipe,
    FinancialInformationComponent,
    EmptyValuePipe,
    // Shared components
    DocumentTypeInputComponent,
    DistanceUnitPipe,
    LastUpdateFormatPipe,
    DeliveryNoteSectionComponent,
    ReportSectionComponent,
    ModalUploadDeliveryNoteComponent,
    ModalConfirmComponent,
    DeliveryNoteUploadButtonComponent
  ],
  providers: [
    { provide: TUI_DATE_FORMAT, useValue: 'DMY' },
    { provide: TUI_DATE_SEPARATOR, useValue: '/' },
    {
      provide: TUI_DATE_VALUE_TRANSFORMER,
      useClass: ExampleDateTransformer,
    },
    {
      provide: TUI_DATE_RANGE_VALUE_TRANSFORMER,
      deps: [TUI_DATE_VALUE_TRANSFORMER],
      useFactory: getExampleDateRangeTransformer,
    },
    ProvidersTableComponent,
    ModalAddProviderComponent,
    ModalAddEventOrIncidenceComponent,
    ModalAddClientComponent,
    TuiSortByDirective,
    TuiSortableDirective,
    MapaPoolManagerComponent,
    UnassignDriverModalComponent,
    SaveChangesModalComponent,
    SaveWithoutChangeModalComponent,
    AddCostModalComponent,
    tuiHintOptionsProvider({
      appearance: 'white',
      direction: 'right',
      showDelay: 50,
      hideDelay: 25,
    }),
  ],
})
export class SharedModule {}
